import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import { GetIntervalMessagesResponse } from '../../types'

function useQueryGetAllIntervalMessages(
	props?: UseBaseQueryOptions<GetIntervalMessagesResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetIntervalMessages],
		queryFn: () => MessagingService.getIntervalMessages(),
		...props,
	})
}

export default useQueryGetAllIntervalMessages
